import React, {Component} from 'react';
import {
    AJAX,
    showPreloader,
    hidePreloader,
    show_popup,
    close_popup,
    addStepLog,
    setUrlSinglePageApp
} from "../functions";
import {Redirect} from "react-router-dom";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {withRouter} from "react-router";


class ReturnPopupActions extends Component {
	constructor(props) {
		super(props);
	}

	goBack() {
		close_popup();
	}

	render() {
		return (
			<div className="row">
				<div className="col-12 text-center">
					<div className="row m-3">
						<div className="col-12 text-center gray">
                            Placing the keys back in the glovebox or driver’s side door is an important safety measure to ensure a reliable
                            storage area for the next hire. Please go back and return the keys to the glovebox or driver’s side door.
						</div>
					</div>
					<div className="row mx-3">
						<div className="offset-3 col-6 text-center">
							<button type="button" className="go-btn go-back mb-4" onClick={this.goBack.bind(this)} />
						</div>
					</div>
				</div>
			</div>
		);
	}
}


class ReturnKeysPage extends Component {

    constructor(props) {
        super(props);
        this.handleSetPage = this.handleSetPage.bind(this);
        this.allowGoNext = this.allowGoNext.bind(this);
        this.handleClickYes = this.handleClickYes.bind(this);
        this.handleClickNo = this.handleClickNo.bind(this);
        this.handleGoNext = this.handleGoNext.bind(this);
        this.sendAnswer = this.sendAnswer.bind(this);
        this.handleSetPage({name: 'return_vehicle', params: false});
        let keys_glovebox = this.props.booking_state.keys_glovebox;
        this.state = {
            go_next: keys_glovebox === 'yes',
            redirect: false,
            answer: keys_glovebox ? keys_glovebox : null
        };

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    handleSetPage(options) {
        if (options.name == 'return_vehicle')
            addStepLog('Return keys Page');
        this.props.handleSetPage(options);
    }

    allowGoNext() {
        this.setState({go_next: true});
    }
    disallowGoNext() {
        this.setState({go_next: false});

    }

    handleClickYes() {
       addStepLog('Press button YES on Return keys page');
       this.setState({answer: 'yes'});
       this.allowGoNext();
    }

    handleClickNo() {
        addStepLog('Press button NO on Return keys page');
        this.setState({answer: 'no'});
        this.disallowGoNext();
        close_popup();
        show_popup(<ReturnPopupActions handleSetPage={this.handleSetPage} handleGoNext={this.handleGoNext}/>, {auto_close: false});
    }

    handleGoNext() {
        this.setState({redirect: true});
    }

    classNameSelectedAnswer(current) {
        if (this.state.answer === current)
            return ' selected';
        return '';
    }

    sendAnswer() {
        addStepLog('Press button goNext on Return keys Page');
        let t = this;

        if (!t.state.go_next) {
            return false;
        }

        let params = {
            session_key: t.props.session_key,
            global_operation: t.props.global_operation,
            answer_key: 'keys_glovebox',
            answer_value: t.state.answer,
            action: 'api/booking/send_answer'
        };

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1 && Object.keys(resp.data).length) {
                    t.props.handleSetBookingState(resp.data.booking_state);
                    t.setState({answer: t.props.booking_state.keys_glovebox});
                    t.handleGoNext();
                } else {
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    render() {

        if (this.state.redirect)
            return <Redirect push to="/send_comment" />;

        return (<>
            <RedirectOnlyHome />
            <div className={'value-space'}>
                <div className="row">
                    <div className="offset-2 col-8">
                        <h1 className="my-4">Have you returned the keys to the glovebox or driver’s side door?</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-2 col-8 text-center">
                        <div className="mb-3">
                            <button type="button" className={"base-input white-green mb-4"+this.classNameSelectedAnswer('yes')} onClick={this.handleClickYes.bind(this)}>
                                YES
                            </button>
                            <button type="button" className={"base-input white-red mb-4"+this.classNameSelectedAnswer('no')} onClick={this.handleClickNo.bind(this)}>
                                NO
                            </button>
                        </div>
                    </div>
                </div>
                {
                    this.state.go_next ? (
                        <div className="row mx-3">
                            <div className={'col-12 text-center'}>
                                <button type="button" className={'go-btn go-next'+(this.state.go_next ? '' : ' disabled')} onClick={this.sendAnswer} disabled={!this.state.go_next} />
                                {/*<button type="button" className={'base-input mb-4 green'+(this.state.go_next ? '' : ' disabled')} onClick={this.sendAnswer} disabled={!this.state.go_next}>*/}
                                {/*    NEXT*/}
                                {/*</button>*/}
                            </div>
                        </div>
                    ) : ('')
                }
            </div>
        </>);
    }
}

const ReturnKeysPageR = withRouter(ReturnKeysPage);
export default ReturnKeysPageR;
